"use strict";

var LoggerInstance = require("js-logger").get("ShippingHelper");

var CheckoutApi = require("./CheckoutApi");
var CheckoutConstants = require("./CheckoutConstants");
var CheckoutStore = require("./CheckoutStore");

var ShipToAccountHelper = require("../commonComponents/ShipToAccountHelper");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var ShippingHelper = {
	initializeShippingListeners: function(payPalCallback) {
		// changes to the address that force a shipping calculation have been moved into AccountFormHelper.
		// See CheckoutActions.initializeStore => AccountFormHelper.initializeAccountFormListeners().
		this.updateShipping();

		$("body").one("mainProductQuantityMounted", () => {
			$("input.main-product-quantity").change(() => this.updateShipping());
		});

		$("input[name='selectedShippingMethod']").change(() => {
			this.updateSelectedShippingMethod();
		});
	},

	updateSelectedShippingMethod: function () {
		var shippingMethod = $("input[name=selectedShippingMethod]:checked").val();

		Dispatcher.dispatch({
			actionType: Constants.SHIPPING_METHOD_UPDATED,
			shippingMethod
		});

		Dispatcher.dispatch({
			actionType: CheckoutConstants.VALIDATE_PAYPAL_CHECKOUT
		});
	},

	updateShipping: function() {
		var products = null;
		var singleProductCode = CheckoutStore.get("productCode");
		if (singleProductCode) {
			//If we are on a Product Page, get the product details
			products = [
				{
					discountAmount: CheckoutStore.get("productDiscount"),
					hasFreeShipping: CheckoutStore.get("hasOnlyDownloadableOrFreeShippingProducts"),
					isShippable: CheckoutStore.get("hasShippableProducts"),
					price: CheckoutStore.get("productPrice"),
					productCode: singleProductCode,
					quantity: $("input.main-product-quantity").val() || 1 //Cannot access ProjectStore because we are in the checkoutComponents bundle not commonComponents bundle
				}
			];
		}

		products = products || CheckoutStore.getCartProducts() || [];
		//Try to get an address on the page, otherwise, try to get the shippingAddress, if they are logged in.
		var address = ShipToAccountHelper.getShippingAddress();

		if (!CheckoutStore.get("hasShippableProducts") || (!address.id && (!address.line1 || !address.city || !address.postalCode || !address.country))) {
			//We do not have enough data to get the shipping information or we do not have any shippable products, so shipping is not required
			Dispatcher.dispatch({
				actionType: Constants.SHIPPING_CANNOT_BE_CALCULATED
			});

			return;
		}

		if (CheckoutStore.get("hasOnlyDownloadableOrFreeShippingProducts")) {
			//We only have items that are free to ship
			Dispatcher.dispatch({
				actionType: Constants.SHIPPING_IS_ALL_FREE
			});

			return;
		}

		//Similar code for this is in Services StudioOnlineTransactionLogic.CalculateShippingAmount
		var shippingQuoteRequest = {
			address,
			company: CheckoutStore.get("company"),
			products: products.filter(product => product.isShippable && !product.hasFreeShipping).map(product => {
				return {
					discountAmount: product.discountAmount,
					price: product.price,
					productCode: product.productCode,
					quantity: product.quantity
				};
			}),
			warehouse: CheckoutStore.get("warehouse"),
			allowedShippingMethods: CheckoutStore.getShippingMethodsForQuote()
		};

		if (_.isEqual(this.previousShippingQuoteRequest, shippingQuoteRequest) && (CheckoutStore.get("shippingRates") || this.inProgress)) {
			LoggerInstance.debug("We do not need to try to calculate shipping because the request is the same as last time and we either have rates or an API call is in progress.");
			return;
		}

		//Logging current request as previous and making note that a request is beginning
		this.previousShippingQuoteRequest = shippingQuoteRequest;
		this.inProgress = true;
		Dispatcher.dispatch({
			actionType: Constants.SHIPPING_REQUEST_PENDING
		});

		//Making the shiping API request
		CheckoutApi.getShippingQuote(shippingQuoteRequest).done((data, textStatus, jqXHR) => {
			Dispatcher.dispatch({
				actionType: Constants.SHIPPING_UPDATED,
				shippingRates: data
			});
		}).fail((jqXHR, textStatus, errorThrown) => {
			this.previousAddress = null;
			Dispatcher.dispatch({
				actionType: Constants.SHIPPING_UPDATE_FAILED,
				jqXHR
			});
		}).always(() => {
			this.inProgress = false;
		});
	},

	isAddressSame: function(address) {
		if (!this.previousAddress) {
			return false;
		}

		return this.previousAddress.type === address.type &&
		this.previousAddress.line1 === address.line1 &&
		this.previousAddress.line2 === address.line2 &&
		this.previousAddress.line3 === address.line3 &&
		this.previousAddress.line4 === address.line4 &&
		this.previousAddress.city === address.city &&
		this.previousAddress.state === address.state &&
		this.previousAddress.postalCode === address.postalCode &&
		this.previousAddress.country === address.country;
	}
};

module.exports = ShippingHelper;



// WEBPACK FOOTER //
// ./Javascript/checkoutComponents/ShippingHelper.jsx